export default function connectWsToDispatch(websocket, dispatch, getState) {
  websocket.receive(dispatch, getState)
}
